// components/TradingCommand/DayPnLSummary.js
import React from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';

const DayPnLSummary = ({
  dayPL,
  realizedPL,
  unrealizedPL,
  activePositions,
  closedTrades,
  winRate,
  avgHoldTime,
  medianHoldTime,
  bestTrade,
  worstTrade,
  totalFees
}) => {
  const wins = closedTrades > 0 ? Math.round((winRate / 100) * closedTrades) : 0;
  const losses = closedTrades - wins;
  
  const showWarning = dayPL < -500 || unrealizedPL < -300;

  const warningTooltip = (
    <Tooltip id="warning-tooltip">
      <strong>Risk Alert:</strong><br />
      {dayPL < -500 && "Day P&L exceeds -$500 threshold"}<br />
      {unrealizedPL < -300 && "Unrealized loss exceeds -$300 threshold"}
    </Tooltip>
  );

  return (
    <Card className="mb-2" style={{ backgroundColor: "#1a1a1a", color: "white", border: "1px solid #333" }}>
      <Card.Body className="py-2 px-3">
        <div className="d-flex justify-content-between align-items-center" style={{ fontSize: '14px' }}>
          {/* Day P&L - Large */}
          <div className="d-flex align-items-center">
            <span style={{ color: '#999', marginRight: '8px' }}>Day P&L:</span>
            <strong 
              style={{ 
                fontSize: '20px',
                color: dayPL >= 0 ? '#28a745' : '#dc3545'
              }}
            >
              {dayPL >= 0 ? '+' : ''}${dayPL.toFixed(2)}
            </strong>
          </div>


          {/* Unrealized */}
          <div>
            <span style={{ color: '#999' }}>Unrealized</span>
            <strong 
              style={{ 
                marginLeft: '4px',
                color: unrealizedPL >= 0 ? '#28a745' : '#dc3545'
              }}
            >
              {unrealizedPL >= 0 ? '+' : ''}${unrealizedPL.toFixed(2)}
            </strong>
          </div>

          {/* Avg Hold */}
          <div>
            <span style={{ color: '#999' }}>Avg Hold:</span>
            <strong style={{ marginLeft: '4px', color: 'white' }}>{avgHoldTime}min</strong>
          </div>
          
          {/* Median Hold */}
          <div>
            <span style={{ color: '#999' }}>Median Hold:</span>
            <strong style={{ marginLeft: '4px', color: 'white' }}>{medianHoldTime}min</strong>
          </div>
          {/* Fees */}
          <div>
            <span style={{ color: '#999' }}>Fees:</span>
            <strong style={{ marginLeft: '4px', color: '#dc3545' }}>
              -${totalFees.toFixed(2)}
            </strong>
          </div>

          {/* Best Trade */}
          <div>
            <span style={{ color: '#999' }}>Best Trade</span>
            <strong 
              style={{ 
                marginLeft: '4px',
                color: '#28a745'
              }}
            >
              +${bestTrade.toFixed(2)}
            </strong>
          </div>

          {/* Worst Trade */}
          <div>
            <span style={{ color: '#999' }}>Worst Trade</span>
            <strong 
              style={{ 
                marginLeft: '4px',
                color: '#dc3545'
              }}
            >
              ${worstTrade.toFixed(2)}
            </strong>
          </div>

          {/* Warning Icon with Tooltip */}
          {showWarning && (
            <OverlayTrigger
              placement="bottom"
              overlay={warningTooltip}
            >
              <div style={{ cursor: 'pointer' }}>
                <span style={{ fontSize: '18px' }}>⚠️</span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default DayPnLSummary;